"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderedPrintLayout = void 0;

var _PrintLayout = require("../model/PrintLayout");

var _Restaurant = require("../model/Restaurant");

var _Liquid = require("./Liquid");

var _RenderedOrder = require("./RenderedOrder");

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Renders a Print by combining a PrintLayout with the
 * required context.
 * @class
 */
class RenderedPrintLayout {
  /**
   * 
   * @param {PrintLayout} printLayout The Mail Template as base
   * @param {Restaurant} restaurant The Restaurant related with this Mail
   * @param {RenderedOrder} renderedOrder The Restaurant related with this Mail
   */
  constructor(printLayout, restaurant, renderedOrder = undefined) {
    this._printLayout = printLayout;
    this._restaurant = restaurant;
    this._renderedOrder = renderedOrder;
  }
  /**
   * The Title to be used for the Mail,
   * Rendered by using Delivery Boostings Flavour of LiquidJS
   * @type {String}
   */


  get title() {
    return _Liquid.LiquidEngine.parseAndRenderSync(this._printLayout.title, {
      order: this._renderedOrder,
      restaurant: this._restaurant,
      now: new Date().getTime()
    });
  }
  /**
   * The body markup of the Mail,
   * Rendered by using Delivery Boostings Flavour of LiquidJS
   * @type {String}
   */


  get markup() {
    return _Liquid.LiquidEngine.parseAndRenderSync(this._printLayout.markup, {
      order: this._renderedOrder,
      restaurant: this._restaurant,
      now: new Date().getTime()
    });
  }

}

exports.RenderedPrintLayout = RenderedPrintLayout;